import React from "react";
import PrivacyPolicy from "./components/PrivacyPolicy";
import TermsOfService from "./components/TermsOfService";

const SimpleRouter = ({ page, children }) => {
  if (page === "privacy") return <PrivacyPolicy />;
  if (page === "terms") return <TermsOfService />;
  return children;
};

export default SimpleRouter;
